export default __webpack_public_path__ + "static/media/UElogo_whiteback.eadd4275.png";